import { z } from 'zod';

export const globalModuleSchema = z
  .object({
    virtualKeyboard: z.boolean().default(false),
    jumboMode: z.boolean().default(false),
  })
  .default({});
